// ======================================================================
// File Name       : LoginConstant
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const LOGIN_TYPE = {
  SUPERUSER: 0,
  USER_SERVICE: 1,
};
